export type CityCoord = { name: string; latitude: number; longitude: number }

export const CITY_COORDINATES: Record<string, CityCoord> = {
  brisbane: { name: 'Brisbane', latitude: -27.4698, longitude: 153.0251 },
  sydney: { name: 'Sydney', latitude: -33.8688, longitude: 151.2093 },
  melbourne: { name: 'Melbourne', latitude: -37.8136, longitude: 144.9631 },
  perth: { name: 'Perth', latitude: -31.9505, longitude: 115.8605 },
  adelaide: { name: 'Adelaide', latitude: -34.9285, longitude: 138.6007 },
  regional: { name: 'Australia', latitude: -25.2744, longitude: 133.7751 },
  anotherCountry: { name: 'Australia', latitude: -25.2744, longitude: 133.7751 },
  notSure: { name: 'Australia', latitude: -25.2744, longitude: 133.7751 },
  another_country: { name: 'Australia', latitude: -25.2744, longitude: 133.7751 },
  not_sure: { name: 'Australia', latitude: -25.2744, longitude: 133.7751 },
}

export const DEFAULT_ORIGIN: CityCoord = { name: 'Chile', latitude: -33.4489, longitude: -70.6693 }
export const DEFAULT_DESTINATION: CityCoord = CITY_COORDINATES.sydney

// Country name / ISO code → capital or major city coordinates.
export const ORIGIN_COUNTRY_COORDINATES: Record<string, CityCoord> = {
  chile: { name: 'Chile', latitude: -33.4489, longitude: -70.6693 },
  brazil: { name: 'Brazil', latitude: -23.5505, longitude: -46.6333 },
  colombia: { name: 'Colombia', latitude: 4.711, longitude: -74.0721 },
  mexico: { name: 'Mexico', latitude: 19.4326, longitude: -99.1332 },
  argentina: { name: 'Argentina', latitude: -34.6037, longitude: -58.3816 },
  peru: { name: 'Peru', latitude: -12.0464, longitude: -77.0428 },
  ecuador: { name: 'Ecuador', latitude: -0.1807, longitude: -78.4678 },
  venezuela: { name: 'Venezuela', latitude: 10.4806, longitude: -66.9036 },
  bolivia: { name: 'Bolivia', latitude: -16.5, longitude: -68.15 },
  uruguay: { name: 'Uruguay', latitude: -34.9011, longitude: -56.1645 },
  paraguay: { name: 'Paraguay', latitude: -25.2867, longitude: -57.647 },
  spain: { name: 'Spain', latitude: 40.4168, longitude: -3.7038 },

  // North America
  united_states: { name: 'United States', latitude: 38.9072, longitude: -77.0369 },
  canada: { name: 'Canada', latitude: 45.4215, longitude: -75.6972 },

  // Europe
  united_kingdom: { name: 'United Kingdom', latitude: 51.5074, longitude: -0.1278 },
  france: { name: 'France', latitude: 48.8566, longitude: 2.3522 },
  germany: { name: 'Germany', latitude: 52.52, longitude: 13.405 },
  italy: { name: 'Italy', latitude: 41.9028, longitude: 12.4964 },
  portugal: { name: 'Portugal', latitude: 38.7223, longitude: -9.1393 },
  netherlands: { name: 'Netherlands', latitude: 52.3676, longitude: 4.9041 },
  sweden: { name: 'Sweden', latitude: 59.3293, longitude: 18.0686 },
  norway: { name: 'Norway', latitude: 59.9139, longitude: 10.7522 },
  poland: { name: 'Poland', latitude: 52.2297, longitude: 21.0122 },
  greece: { name: 'Greece', latitude: 37.9838, longitude: 23.7275 },

  // Africa
  south_africa: { name: 'South Africa', latitude: -25.7479, longitude: 28.2293 },
  nigeria: { name: 'Nigeria', latitude: 9.0765, longitude: 7.3986 },
  egypt: { name: 'Egypt', latitude: 30.0444, longitude: 31.2357 },
  kenya: { name: 'Kenya', latitude: -1.2921, longitude: 36.8219 },
  morocco: { name: 'Morocco', latitude: 34.0209, longitude: -6.8416 },

  // Asia
  china: { name: 'China', latitude: 39.9042, longitude: 116.4074 },
  india: { name: 'India', latitude: 28.6139, longitude: 77.209 },
  japan: { name: 'Japan', latitude: 35.6762, longitude: 139.6503 },
  south_korea: { name: 'South Korea', latitude: 37.5665, longitude: 126.978 },
  indonesia: { name: 'Indonesia', latitude: -6.2088, longitude: 106.8456 },
  thailand: { name: 'Thailand', latitude: 13.7563, longitude: 100.5018 },
  vietnam: { name: 'Vietnam', latitude: 21.0278, longitude: 105.8342 },
  philippines: { name: 'Philippines', latitude: 14.5995, longitude: 120.9842 },
  pakistan: { name: 'Pakistan', latitude: 33.6844, longitude: 73.0479 },
  bangladesh: { name: 'Bangladesh', latitude: 23.8103, longitude: 90.4125 },
  turkey: { name: 'Turkey', latitude: 39.9334, longitude: 32.8597 },
  saudi_arabia: { name: 'Saudi Arabia', latitude: 24.7136, longitude: 46.6753 },
  united_arab_emirates: { name: 'United Arab Emirates', latitude: 24.4539, longitude: 54.3773 },
  israel: { name: 'Israel', latitude: 31.7683, longitude: 35.2137 },

  // Oceania
  australia: { name: 'Australia', latitude: -35.2809, longitude: 149.13 },
  new_zealand: { name: 'New Zealand', latitude: -41.2866, longitude: 174.7756 },
}

export function resolveOrigin(originCountry?: string | null): CityCoord {
  if (!originCountry) return DEFAULT_ORIGIN
  const key = originCountry.toLowerCase().trim()
  return ORIGIN_COUNTRY_COORDINATES[key] ?? DEFAULT_ORIGIN
}
